<template lang="html">
    <div ref="side" class="side-content" :class="sidestate">
      <div class="side-inner">
            <div class="side-line side-line1">
                  <div class="line-name">
                       <span v-if="inType==1">已选分类：</span>
                       <span v-else-if="inType==2">已选创作者：</span>
                       <span v-else-if="inType==3">已选主题词：</span>
                       <span v-else-if="inType==4">已选出版者：</span>
                       <span v-else>已选出版年代：</span>
                  </div>
                  <div class="line-text">
                       <span v-for="(item,index) in selectedArr[0]" :key="index">{{item | itemNames}}</span>
                  </div>
            </div>
            <div class="side-line side-line2" @click="selectClean">
                  <div class="select-ccl">
                        <div v-if="selectedArr[0].length == 0" class="selected"></div>
                  </div>
                  <div class="line-name" v-if="inType==1">全部分类</div>
                  <div class="line-name" v-else-if="inType==2">全部创作者</div>
                  <div class="line-name" v-else-if="inType==3">全部主题词</div>
                  <div class="line-name" v-else-if="inType==4">全部出版者</div>
                  <div class="line-name" v-else>全部出版年代</div>
            </div>
            <Block v-for="(item,key) in preDat[0]" :key="key" :classDat="item" :classKey="key" @select="select" :selectedArr="selectedArr[0]"/>

      </div>
      <div class="side-btns">
             <div class="s-btn" @click="firmSelect(1)">取消</div>
             <div class="s-btn" @click="firmSelect(2)">确认</div>
      </div>

    </div>
</template>

<script>
import Block from "./src/block";
import vEmits from "@/utils/vEmits";
export default {
   components:{
       Block
   },
   props:['inDat','inType'],
   watch:{
       inDat:function(){
          this.datFormat();
       }
   },
   filters:{
       itemNames:function(e){
          let text = e.text || e.name;
          if(text == '全部'){
              text = '全部' + e.classKey;
          }
          return text;
       }
   },
   data(){
       return{
            sidestate:'',
            listH:'',
            preDat:[{}],
            innerType:1,
            selectedArr:[[]],
            prevSelected:[[]]
       }
   },
   methods:{
       sideOpen:function(){
           this.sidestate = 'act';
           let arrs = [];
           for(let i in this.selectedArr[0]){
               arrs.push(this.selectedArr[0][i]);
           }
           this.prevSelected.splice(0,1,arrs);
       },
       sideClose:function(){
           this.sidestate = 'hide';
           this.$emit('modelClose');
       },
       classFormate:function(newDat){
             function arrGet(tree,arrs){
                 if(tree.classifyList.length > 0){
                     let tempClass = tree.classifyList;
                     for(let i = 0;i < tempClass.length;i++){
                         arrGet(tempClass[i],arrs);
                     }
                 }else{
                     arrs.push(tree);
                 }
                 return arrs;
             }
             for(let i = 0;i < this.inDat.classifyList.length;i++){
                 if(this.inDat.classifyList[i].classifyList.length > 0){
                      newDat[this.inDat.classifyList[i].text] = arrGet(this.inDat.classifyList[i],[]);
                 }
             }
       },
       authorFormate:function(newDat){
             let keyMap = {
                 celebrityLyricList:'词作家',
                 composerList:'曲作家',
                 musicArrangementList:'编曲',
                 changeArrangementList:'改编',
                 singerList:'演唱',
                 accompanySingerList:'伴唱',
                 directList:'指挥',
                 renditionList:'演奏',
                 renditionInstrumentList:'演奏乐器'
             };

             for(let key in keyMap){
                 if(this.inDat[key].length > 0){
                      for(let i = 0;i < this.inDat[key].length;i++){
                          this.inDat[key][i].postKey = key;
                      }
                      newDat[keyMap[key]] = this.inDat[key];
                 }
             }

       },
       themeFormate:function(newDat){
             function arrGet(tree,arrs){
                 if(tree.classifyList.length > 0){
                     let tempClass = tree.classifyList;
                     for(let i = 0;i < tempClass.length;i++){
                         arrGet(tempClass[i],arrs);
                     }
                 }else{
                     arrs.push(tree);
                 }
                 return arrs;
             }
             for(let i = 0;i < this.inDat.thematicWordsList.length;i++){
                 if(this.inDat.thematicWordsList[i].classifyList.length > 0){
                      newDat[this.inDat.thematicWordsList[i].text] = arrGet(this.inDat.thematicWordsList[i],[]);
                 }
             }
       },
       companyFormate:function(){
            let newArr = [];
            for(let i = 0;i < this.inDat.publishList.length;i++){
                newArr.push({
                    id:this.inDat.publishList[i],
                    text:this.inDat.publishList[i],
                    postKey:'publishList'
                });
            }
            return newArr;
       },
       yearFormate:function(){
             let newArr = [];
             for(let i = 0;i < this.inDat.publishYearList.length;i++){
                 let tempStr = this.inDat.publishYearList[i].split("|");
                 if(tempStr[1]){
                     if(newArr[0]){
                         newArr = newArr.concat(tempStr[1].split(","));
                     }else{
                         newArr = tempStr[1].split(",");
                     }
                 }else{
                     newArr.push('1990+');
                 }
             }

             let fmArr = [];
             for(let i = 0;i < newArr.length;i++){
                 fmArr.push({
                      id:newArr[i],
                      text:newArr[i],
                      postKey:'publishYearList'
                 })
             }

             return fmArr;
       },
       classPrevFmt:function(e,key){
             let arrs = this.selectedArr[0];
             let canAdd = false;
             let transId = {'中国戏曲':'1090','中国曲艺':'1093','民族歌曲':'1091','歌舞音乐':'1094','民族器乐':'1092'};
             if(arrs.length == 0){
                 canAdd = true;
             }else{
                 for(let i = 0;i < arrs.length;i++){
                     if(arrs[i].id == transId[key]){
                         canAdd = true;
                     }
                 }
             }
             if(canAdd){
                 e[key].unshift({
                      id:transId[key],
                      text:'全部'
                 })
             }
       },
       datFormat:function(){
             let newDat = {};
             if(this.inType == 1){
                 this.classFormate(newDat);
                 for(let key in newDat){
                     this.classPrevFmt(newDat,key);
                 }
             }else if(this.inType == 2){
                 this.authorFormate(newDat);
             }else if(this.inType == 3){
                 this.themeFormate(newDat);
             }else if(this.inType == 4){
                 newDat['出版者'] = this.companyFormate();
             }else if(this.inType == 5){
                 newDat['出版年代'] = this.yearFormate();
             }
             this.preDat.splice(0,1,newDat);
       },
       select:function(item){
             let selected = false;
             let arrs = this.selectedArr[0];
             for(let i = 0;i < arrs.length;i++){
                 if(arrs[i].id == item.id){
                      selected = true;
                      arrs.splice(i,1);
                      break;
                 }
             }

             let isFilled = false;
             if(arrs.length == 5){
                 isFilled = 1;
             }

             if(this.inType == 1){
                 for(let i = 0;i < arrs.length;i++){
                     if(arrs[i].classKey != item.classKey){
                          isFilled = 2;
                          break;

                     }
                 }
             }

             if(!selected){
                 if(isFilled){
                     if(isFilled == 1){
                         vEmits.$emit('show','最多只能添加5项 !');
                     }else if(isFilled == 2){
                         vEmits.$emit('show','音乐分类只支持单项大分类下查询 !');
                     }

                 }else{
                     if(this.inType == 1){
                         item.postKey = 'classifyList';
                         if(item.text == '全部'){
                            arrs.splice(0,arrs.length);
                         }else{
                            for(let i = 0;i < arrs.length;i++){
                                if(arrs[i].text == '全部'){
                                    arrs.splice(i,1);
                                    break;
                                }
                            }
                         }
                     }else if(this.inType == 3){
                         item.postKey = 'thematicWordsList';
                     }else if(this.inType == 4){
                         item.postKey = 'publishList';
                     }
                     this.selectedArr[0].push(item);
                 }
             }
       },
       firmSelect:function(type){
             if(type == 1){
                 this.selectedArr.splice(0,1,this.prevSelected[0]);
             }
             this.$emit('selected',{
                  data:this.selectedArr[0],
                  type:this.inType
             })
             this.sideClose();
       },
       selectClean:function(){
             this.selectedArr.splice(0,1,[]);
       }
   },
   created:function(){
       let querys = this.$route.query;
       if(querys.classId){
          if(querys.classType == this.inType){
              let temp = {
                  id:querys.classId,
                  postKey:"classifyList",
                  text:querys.classText
              }
              this.selectedArr[0].push(temp);
              this.firmSelect();
              this.$emit('selected',{
                   data:this.selectedArr[0],
                   type:this.inType
              })
          }
       }

   }
}
</script>

<style lang="css" scoped>

.side-content{
    width: 325px;
    height: 100%;
    position: absolute;
    background: white;
    top: 0px;
    right: -325px;
    transform: translate3d(0,0,0);
}

.side-inner{
    width: 325px;
    height: 587px;
    position: relative;
    overflow-y: scroll;
}

.side-content.act{
    transition-duration: 0.3s;
    transition-timing-function: ease-in-out;
    transition-property: all;
    transform: translate3d(-325px,0,0);
}

.side-content.hide{
    transition-duration: 0.3s;
    transition-timing-function: ease-in-out;
    transition-property: all;
    transform: translate3d(0,0,0);
}

.side-content{
    padding-top: 30px;
}

/* 分类 */

.side-line{
    margin-left: 10px;
    display: flex;
    align-items: flex-start;
    font-size: 15px;
    border-bottom: 1px solid #efefef;
}

.side-line1{
    padding-bottom: 12px;
    justify-content: space-between;
    padding-right: 12px;
}

.side-line2{
    height: 45px;
    align-items:center;
}

.side-line .line-name{
    width: 112px;
    font-size: 15px;
    flex-shrink: 0;
}

.side-line .line-text{
    color: #666666;
}

.side-line .line-text span{
    font-size: 14px;
    color: #999999;
    display: inline-block;
    margin-right: 6px;
}

.select-ccl{
    width: 16px;
    height: 16px;
    border-radius: 16px;
    border: 1px solid #af2d2d;
    position: relative;
    box-sizing: border-box;
    margin-right: 3px;
}

.select-ccl .selected{
    width: 12px;
    height: 12px;
    border-radius: 12px;
    background: #af2d2d;
    position: absolute;
    left: 1px;
    top: 1px;
}

/* 底部却认按钮 */

.side-btns{
    position: absolute;
    z-index: 2;
    left: 0px;
    bottom: 30px;
    display: flex;
    height: 50px;
    width: 100%;
}

.side-btns .s-btn{
    height: 50px;
    flex-grow: 1;
    background: #efefef;
    color: #666666;
    text-align: center;
    line-height: 50px;
}

.side-btns .s-btn:first-child{
    border-right: 1px solid #ebe4e4;
}

.side-btns .s-btn:last-child{
    border-left: 1px solid #ebe4e4;
    background: #af2d2d;
    color: white;
}

</style>
